/**
 * `/app/widgets/$widgetRef/forms` — the forms on a forms widget. The page is
 * `pages/forms/FormsPage.tsx`.
 */

import { createFileRoute } from '@tanstack/react-router'

import { NotFound } from '../../../../../errors/NotFound.js'
import { FormsPage } from '../../../../../pages/forms/FormsPage.js'

export const Route = createFileRoute('/app/widgets/$widgetRef/forms/')({
  notFoundComponent: NotFound,
  component: FormsRoute,
})

function FormsRoute() {
  const { widgetRef } = Route.useParams()
  return <FormsPage widgetRef={widgetRef} />
}
